export const formatPrice = (val) => {
    if (val === undefined || val === null || val === "") return "0.00";
    const num = Number(val);
    if (isNaN(num)) return String(val);
    return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
